const state = () => ({
  version: process.env.APP_VERSION,
});

export default {
  namespaced: true,
  state,
};
